import { Inbox, ListChecks, Users, type LucideIcon } from "lucide-react";

export interface NavDestination {
  path: string;
  labelKey: string;
  icon: LucideIcon;
}

/**
 * The console's navigating destinations, in rail order. `NavRail` (desktop)
 * and `TabBar` (below 960px) are the same list rendered into two different
 * chromes, so they read it from here rather than each keeping its own copy —
 * mirroring `apps/client`'s `src/app/routes.ts`.
 *
 * Icons are lucide-react, as in `apps/client`. The tab bar's fourth,
 * non-navigating Account tab is not here: it opens a sheet rather than a
 * route, and the rail carries that identity block in its own footer.
 */
export const NAV_DESTINATIONS: NavDestination[] = [
  { path: "/queue", labelKey: "nav.queue", icon: Inbox },
  { path: "/customers", labelKey: "nav.customers", icon: Users },
  { path: "/tasks", labelKey: "nav.tasks", icon: ListChecks },
];
